import React, { useState } from "react";
import { Card, CardBody, Button } from "react-bootstrap";
import { motion } from "framer-motion";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import TemplateAgendamento from "./TemplateAgendamento";
import { dateDbToBr, float2moeda } from "../utils/Funcoes";
import { faCircleCheck } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const ConfirmAgendamento = ({ dados, theme, onVoltar }) => {


  const navigate = useNavigate()
  const { dominio } = useParams();
  const [isLogin, setIsLogin] = useState(true);
  const location = useLocation()
  const dadosAgendamento = location.state?.dadosAgendamento
  console.log(dadosAgendamento)
  return (
    <TemplateAgendamento>

      <div className="min-vh-100 d-flex justify-content-center align-items-center p-3 bg-light">
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="w-100" style={{ maxWidth: "500px" }}
        >
          <Card className="shadow border-0 rounded-4 p-2" style={{ background: theme?.cardBg, color: theme?.text }} >
            <CardBody className="text-center">

              <h2 className="fw-bold mb-3 text-success" ><FontAwesomeIcon icon={faCircleCheck} /> Agendamento Confirmado!</h2>
              <p className="text-muted mb-4">
                Seu atendimento foi agendado com sucesso. Abaixo estão os detalhes:
              </p>

              <div className="text-start  bg-light rounded p-3 mb-4" style={{ color: 'rgb(69 69 69)' }}>

                <p><strong>Profissional:</strong> {dadosAgendamento?.profissional?.nome}</p>
                <p><strong>Data:</strong> {dadosAgendamento?.data && dateDbToBr(dadosAgendamento?.data)}</p>
                <p><strong>Horário:</strong> {dadosAgendamento?.horario?.hora}</p>
                <p><strong>Serviço:</strong> {dadosAgendamento?.servico?.nome}</p>
                <p><strong>Valor:</strong> {(dadosAgendamento?.servico?.precoVariavel == 1) ? 'A partir de ' : ''} R$  {float2moeda(dadosAgendamento?.servico?.valor)}</p>
                {dadosAgendamento?.observacoes && (
                  <p><strong>Observações:</strong> {dadosAgendamento.observacoes}</p>
                )}
              </div>

              <Button
                style={{ background: theme?.primary, borderColor: theme?.primary }}
                className="rounded-pill px-4 py-2"

                href={"/" + dominio + "/"}
              >Voltar ao início
              </Button>
            </CardBody>
          </Card>
        </motion.div>
      </div>

    </TemplateAgendamento>
  );
};

export default ConfirmAgendamento;
